"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputScene = void 0;
const KHInputProviderController_1 = require("./KHInputProviderController");
const KHInputProviderKeyboard_1 = require("./KHInputProviderKeyboard");
const KHInputProviderMouse_1 = require("./KHInputProviderMouse");
class KHInputScene extends Phaser.Scene {
    constructor() {
        super("KHInputScene");
        this.registeredInputSets = new Set();
        KHInputScene.SharedInput = this;
    }
    registerInputSet(inputSet) {
        this.registeredInputSets.add(inputSet);
        if (this.registeredInputSets.size > 10) {
            console.log("Registered input sets", this.registeredInputSets);
        }
    }
    unregisterInputSet(inputSet) {
        this.registeredInputSets.delete(inputSet);
    }
    create() {
        this.controllerProviders = [
            new KHInputProviderController_1.KHInputProviderController(this, 0),
            new KHInputProviderController_1.KHInputProviderController(this, 1),
            new KHInputProviderController_1.KHInputProviderController(this, 2),
            new KHInputProviderController_1.KHInputProviderController(this, 3)
        ];
        this.keyboardProvider = new KHInputProviderKeyboard_1.KHInputProviderKeyboard(this);
        this.mouseProvider = new KHInputProviderMouse_1.KHInputProviderMouse(this);
        this.events.on('preupdate', (now, delta) => {
            this.updateInputs(now, delta);
        }, this);
    }
    updateInputs(now, delta) {
        // Update mouse inputs first so that bumping the mouse while holding a
        // button doesn't trigger mouse movement.
        this.mouseProvider.update(now, delta);
        for (let i = 0; i < this.controllerProviders.length; i++) {
            this.controllerProviders[i].update(now, delta);
        }
        this.keyboardProvider.update(now, delta);
        // Registered derived inputs must be iterated in the order that they're
        // registered, as this guarantees that a derived input's inputs will
        // be updated before it is, preventing extra input latency.
        this.registeredInputSets.forEach(function (value) {
            value.update(now, delta);
        });
    }
}
exports.KHInputScene = KHInputScene;
